<template>
    <div id="edit-library-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1>Edit Library</h1>
                <template v-if="loaded">
                    <LibraryForm :formData="libraryObject" submitText="Update" @formSubmitted="updateLibrary" />

                    <hr/>

                    <div class="users-section">
                        <h3>Users</h3>
                        <table>
                            <thead>
                                <tr>
                                    <th>_id</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="user of libraryObject.users" :key="user._id">
                                    <td>{{ user._id }}</td>
                                    <td>{{ user.name }}</td>
                                    <td>{{ user.email }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
            </section>
        </div>
    </div>
</template>

<script>
import LibraryForm from '@/components/forms/LibraryForm.vue'
const apiBase = process.env.VUE_APP_API_BASE
import axios from 'axios'

export default {
    name: 'LibrariesEdit',
    components: {
        LibraryForm
    },
    data: function() {
        return {
            libraryId: this.$route.params.id,
            libraryObject: null,
            loaded: false
        }
    },
    created() {
        axios.get(apiBase + '/libraries/' + this.libraryId)
                .then(response => {
                    this.libraryObject = response.data.data
                    this.loaded = true
                })
                .catch(error => {
                    alert('Could not load library!')
                    console.log(error)
                })
    },
    methods: {
        updateLibrary(fd) {
            console.log(fd)
            axios.put(apiBase + '/libraries/' + this.libraryId, fd)
                  .then(() => {
                      //console.log(response)
                      alert('Library updated successfully')
                      this.$router.push('/libraries')
                  })
                  .catch(error => {
                      alert('Error occurred!')
                      console.log(error)
                  })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
